var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAig20Px = function SvgIconAig20Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D81F3",
    d: "M12.988 9.886q.096.301.096.613h3.35a1 1 0 0 0-.171-.556l-5.435-8.066a.98.98 0 0 0-.656-.42q.048.008.096.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#78CCFF",
    d: "m7.013 9.886 2.72-8.41a.98.98 0 0 0-.56.401L3.737 9.942a1 1 0 0 0-.17.557h3.348c0-.207.032-.414.097-.613"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#55B4FB",
    d: "M7.013 11.116a2 2 0 0 1-.097-.616H3.567c0 .195.057.39.17.56l5.435 8.062c.162.24.403.376.657.42q-.049-.006-.096-.02z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0850AC",
    d: "M13.085 10.5c0 .208-.033.416-.097.616l-2.72 8.407q-.048.011-.096.02a.98.98 0 0 0 .656-.421l5.435-8.062a1 1 0 0 0 .17-.56z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#006E87",
    d: "m10.61 1.878 5.323 8.065c.113.169.17.363.17.557h.33a1 1 0 0 0-.17-.557L10.83 1.878a.97.97 0 0 0-.559-.394l.034.104c.117.07.223.166.306.29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#003670",
    d: "M16.103 10.5c0 .195-.056.39-.17.56l-5.322 8.062a1 1 0 0 1-.307.29l-.034.104a.97.97 0 0 0 .559-.394l5.434-8.062a1 1 0 0 0 .17-.56z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#55B4FB",
    d: "M6.916 10.5h6.169q0-.312-.097-.614l-2.72-8.409a1.1 1.1 0 0 0-.535 0l-2.72 8.41c-.065.199-.097.406-.097.612"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#83E2FC",
    d: "M9.892 1.45c-.095.009-.12.017-.16.026l-2.72 8.41c-.064.199-.096.406-.096.613h.62q0-.312.097-.613z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D81F3",
    d: "M12.988 11.116c.064-.2.097-.408.097-.616H6.916c0 .208.032.416.097.616l2.72 8.407c.16.044.371.045.535 0z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#33A3FF",
    d: "M9.892 19.546c-.119-.012-.122-.02-.16-.027l-2.72-8.41a2 2 0 0 1-.096-.613h.62q0 .313.097.613z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#00809E",
    d: "m10.27 1.484 2.718 8.403q.096.301.097.613h.423q0-.312-.097-.613z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFF8FF",
    d: "M9.424 1.621a1 1 0 0 0-.252.256L3.738 9.943a1 1 0 0 0-.17.556h.574c0-.194.057-.388.17-.556z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#003670",
    d: "m10.27 19.516 2.718-8.403q.096-.301.097-.613h.423q0 .313-.097.613z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#85D1FF",
    d: "M9.424 19.378a1 1 0 0 1-.252-.256l-5.434-8.065a1 1 0 0 1-.17-.557h.574c0 .194.057.388.17.557z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.735 6.19-2.906-4.312a1.007 1.007 0 0 0-1.657 0L4.211 9.24c4.975.304 7.858-1.18 9.524-3.05",
    opacity: 0.15
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-AIG-20px_svg__a)",
    d: "M9.192 8.103a1.74 1.74 0 1 0 0-3.48 1.74 1.74 0 0 0 0 3.48",
    opacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-AIG-20px_svg__b)",
    d: "m9.456 6.5.503.629-.63-.504-.138 1.248-.138-1.248-.629.504.503-.63-1.247-.138 1.247-.138-.503-.629.63.503.137-1.247.139 1.247.629-.503-.503.629 1.247.138z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-AIG-20px_svg__c)",
    d: "M6.881 14.652c.43.727.891 1.435 1.38 2.105a26.7 26.7 0 0 0-2.559-4.335c.35.752.747 1.498 1.18 2.23"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-AIG-20px_svg__d)",
    d: "M11.267 16.01a2.318 2.318 0 1 0 0-4.637 2.318 2.318 0 0 0 0 4.637",
    opacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-AIG-20px_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(9.192 6.363)scale(1.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-AIG-20px_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(9.191 6.361)scale(1.5117)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-AIG-20px_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(11.267 13.691)scale(2.31887)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-AIG-20px_svg__c",
    x1: 6.466,
    x2: 5.25,
    y1: 12.902,
    y2: 14.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#fff",
    stopOpacity: 0.999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgIconAig20Px;